import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'sq-sidebar-nav-divider',
    changeDetection: ChangeDetectionStrategy.Eager,
    template: ``,
})
export class SidebarNavDividerComponent {
    @Input() item: any
}
